import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { useRouter } from 'next/router';
import * as Constants from './constants';

import api from '../../lib/restClient';

const ShopTabs = ({ active, setActive }) => {
  const router = useRouter();
  const productID = _.get(router, 'query.productId');
  const codeID = _.get(router, 'query.code');

  const [productReviewCount, setProductReviewCount] = useState(0);

  function getSubscriptionCode(code) {
    switch (code) {
      case 'subscription-1':
        return '4';
      case 'subscription-2':
        return '5';
      case 'subscription-3':
        return '3';
      case 'subscription-4':
        return '15';
      case 'subscription-5':
        return '16';
      default:
        return null;
    }
  }

  const splitLoginProductCode = _(_.get(router, 'query.code'))
    .split('?', 2)
    .value();
  const splitLoginProductID = _(_.get(splitLoginProductCode, '1'))
    .split('=', 2)
    .value();
  const loginProductID = _.get(splitLoginProductID, '1');

  useEffect(() => {
    // 로그인으로 인한 redirect시 url 고려
    async function getData() {
      try {
        const params = {
          limit: 10,
          offset: 0
        };
        const subscriptionCode = getSubscriptionCode(codeID);
        if (subscriptionCode) {
          params.meal_id = subscriptionCode;
        } else {
          params.product_id = productID || loginProductID || '';
        }
        const response = await api.get('/reviews', { params });
        setProductReviewCount(response?.data?.count);
      } catch (error) {
        console.log(error);
      }
    }
    getData();
  }, []);

  const microsaltsLunchBox = productID === '1' || loginProductID === '1';
  const [microsaltsReview, setMicrosaltsReview] = useState(0);
  useEffect(() => {
    if (microsaltsLunchBox) {
      setMicrosaltsReview(411);
    }
  }, []);
  //   const lunchBoxReviewsFilterLength = (productID === '17' ? subscrtipionReview : lunchBoxReviewsFilter).length;
  const handleClick = name => {
    setActive({
      state: true,
      name
    });
  };
  return (
    <Tabs>
      {Constants.SHOP_TABS.map(tab => {
        const { name, value } = tab;
        return (
          <Tab active={value === active.name} onClick={() => handleClick(value)}>
            {name} {name === '고객후기' && `${microsaltsLunchBox ? productReviewCount + microsaltsReview : productReviewCount}`}
          </Tab>
        );
      })}
    </Tabs>
  );
};

const Tabs = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;
const Tab = styled.div`
  cursor: pointer;
  font-size: 1.8rem;
  font-weight: bold;
  width: 100%;
  padding: 1rem 0;
  text-align: center;
  border-bottom: ${props => (props.active ? '4px solid #2f6ecd' : '1px solid #bdbdbd')};
  color: ${props => (props.active ? '#323232' : '#bdbdbd')};
`;
export default ShopTabs;
